
{
  "familyId": "SPR-WEET-D-T",
  "questions": [
    {
      "id": "SPR-WEET-D-T-001",
      "familyId": "SPR-WEET-D-T",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_eind",
      "questionType": "multiple_choice",
      "question": "Welk woord eindigt op een 'd'?",
      "options": ["hond", "kant", "mast", "plant"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "D of T aan het einde?", "content": "Sommige woorden eindigen op een 'd' die klinkt als 't'. Truc: maak het woord langer (meervoud).\n\nhond → honden (je hoort 'd') → schrijf 'd'\nkant → kanten (je hoort 't') → schrijf 't'", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "d_t_eind_herkennen",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Truc: maak het woord langer door het meervoud te maken. Hond → honden — je hoort duidelijk de 'd'. Bij kant → kanten, mast → masten en plant → planten hoor je steeds een 't'. Dus alleen 'hond' eindigt op een 'd'.",
        "solutionSteps": [
          "Maak elk woord meervoud",
          "Hond → honden: je hoort 'd' → eindigt op d ✓",
          "Kant → kanten: je hoort 't' → eindigt op t",
          "Mast → masten: je hoort 't' → eindigt op t",
          "Plant → planten: je hoort 't' → eindigt op t"
        ],
        "distractorExplanations": {
          "0": "Goed! Hond → honden: je hoort de 'd', dus schrijf je 'hond' met een d.",
          "1": "Je dacht waarschijnlijk dat 'kant' op een d eindigt. Maar kant → kanten: je hoort de 't'. Onthoud: maak het woord langer om te horen of het d of t is.",
          "2": "Je dacht waarschijnlijk dat 'mast' op een d eindigt. Maar mast → masten: je hoort de 't'. Onthoud: maak het woord langer.",
          "3": "Je dacht waarschijnlijk dat 'plant' op een d eindigt. Maar plant → planten: je hoort de 't'. Onthoud: maak het woord langer."
        }
      }
    },
    {
      "id": "SPR-WEET-D-T-002",
      "familyId": "SPR-WEET-D-T",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_eind",
      "questionType": "multiple_choice",
      "question": "Welke spelling is correct?",
      "options": ["mond", "mont", "mondt", "mond't"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Meervoud-truc", "content": "Twijfel je of een woord op d of t eindigt? Maak het woord langer!\n\nmond → monden (je hoort 'd') → schrijf 'mond'\nkant → kanten (je hoort 't') → schrijf 'kant'", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "d_t_eind_mond",
      "variantIndex": 2,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Maak het woord langer: mond → monden. Je hoort duidelijk de 'd'. Dus schrijf je 'mond' met een d aan het einde. De andere opties (mont, mondt, mond't) bestaan niet.",
        "solutionSteps": [
          "Maak het woord langer: mond → monden",
          "Je hoort de 'd'-klank",
          "Dus: mond (met d)"
        ],
        "distractorExplanations": {
          "0": "Goed! Mond → monden: je hoort de 'd', dus schrijf je 'mond'.",
          "1": "Je dacht waarschijnlijk dat het 'mont' is met een t. Maar mond → monden: je hoort de 'd'. Onthoud: maak het woord langer om te horen of het d of t is.",
          "2": "'Mondt' is een werkwoordsvorm (hij mondt uit), geen zelfstandig naamwoord. Het lichaamsdeel schrijf je als 'mond'.",
          "3": "'Mond't' bestaat niet. Een apostrof gebruik je hier niet. Het is gewoon 'mond'."
        }
      }
    },
    {
      "id": "SPR-WEET-D-T-003",
      "familyId": "SPR-WEET-D-T",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_eind",
      "questionType": "multiple_choice",
      "question": "Welk woord eindigt op een 'd' (niet op een 't')?",
      "options": ["hond", "kant", "plant", "mast"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "D of T herkennen", "content": "Maak het woord meervoud of voeg '-en' toe:\nhond → honden (je hoort 'd') → eindigt op 'd'\nkant → kanten (je hoort 't') → eindigt op 't'", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "d_t_eind_meervoud_truc",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Truc: maak het woord meervoud. Hond → honden (je hoort de 'd'). Kant → kanten (je hoort de 't'). Plant → planten (je hoort de 't'). Mast → masten (je hoort de 't'). Alleen 'hond' eindigt op 'd'.",
        "distractorExplanations": {
          "0": "Goed! Hond → honden: je hoort de 'd', dus eindigt het op 'd'.",
          "1": "Kant → kanten: je hoort de 't', dus eindigt 'kant' op 't'.",
          "2": "Plant → planten: je hoort de 't', dus eindigt 'plant' op 't'.",
          "3": "Mast → masten: je hoort de 't', dus eindigt 'mast' op 't'."
        }
      }
    },
    {
      "id": "SPR-WEET-D-T-004",
      "familyId": "SPR-WEET-D-T",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_eind",
      "questionType": "multiple_choice",
      "question": "Welke zin is correct gespeld?",
      "options": [
        "De hond rent door het veld.",
        "De hont rent door het veld.",
        "De hond rent door het felt.",
        "De hond rent door het velt."
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "D of T: meervoud-truc", "content": "hond → honden (hoor je 'd') → eindigt op 'd'\nveld → velden (hoor je 'd') → eindigt op 'd'\nNiet: hont of velt!", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "d_t_eind_zin_correct",
      "variantIndex": 4,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Hond → honden (je hoort 'd') → eindigt op 'd'. Veld → velden (je hoort 'd') → eindigt op 'd'. Dus: 'De hond rent door het veld.' is correct.",
        "solutionSteps": [
          "Controleer 'hond': hond → honden (d) ✓",
          "Controleer 'veld': veld → velden (d) ✓",
          "Beide woorden eindigen op d, niet op t"
        ],
        "distractorExplanations": {
          "0": "Goed! Hond (honden) en veld (velden) eindigen beide op 'd'.",
          "1": "'Hont' is fout. Hond → honden: je hoort de 'd', dus eindigt het op 'd'.",
          "2": "'Felt' bestaat niet. Het woord is 'veld' (velden: je hoort de 'd').",
          "3": "'Velt' is fout. Veld → velden: je hoort de 'd', dus eindigt het op 'd'."
        }
      }
    },
    {
      "id": "SPR-WEET-D-T-005",
      "familyId": "SPR-WEET-D-T",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_eind",
      "questionType": "multiple_choice",
      "question": "Welke woorden eindigen ALLE op 'd'?",
      "options": [
        "hond, veld, mond",
        "kant, plant, mast",
        "hond, kant, veld",
        "mond, mast, plant"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Meervoud-truc voor alle woorden", "content": "hond → honden (d) ✓\nveld → velden (d) ✓\nmond → monden (d) ✓\nkant → kanten (t) ✗\nplant → planten (t) ✗\nmast → masten (t) ✗", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "d_t_eind_groep_herkennen",
      "variantIndex": 5,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Meervoud-truc: hond→honden (d), veld→velden (d), mond→monden (d). Alle drie eindigen op 'd'. Kant→kanten (t), plant→planten (t), mast→masten (t) eindigen op 't'.",
        "solutionSteps": [
          "Hond → honden (d) ✓",
          "Veld → velden (d) ✓",
          "Mond → monden (d) ✓",
          "Alle drie eindigen op d"
        ],
        "distractorExplanations": {
          "0": "Goed! Hond, veld en mond eindigen alle drie op 'd' (honden, velden, monden).",
          "1": "Kant, plant en mast eindigen alle drie op 't' (kanten, planten, masten). Niet op 'd'.",
          "2": "Gemengd: hond en veld eindigen op 'd', maar kant eindigt op 't'.",
          "3": "Gemengd: mond eindigt op 'd', maar mast en plant eindigen op 't'."
        }
      }
    },
    {
      "id": "SPR-WEET-D-T-006",
      "familyId": "SPR-WEET-D-T",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_eind",
      "questionType": "fill_in",
      "question": "Vul de juiste letter in: hon_. Typ het hele woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["hond"],
        "caseSensitive": false,
        "placeholder": "hon..."
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Meervoud-truc",
            "content": "Maak het woord meervoud: hond → honden. Je hoort de 'd', dus schrijf je 'hond' met een d.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "d_t_eind_fill_d",
      "variantIndex": 6,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Meervoud-truc: hond → honden. Je hoort de 'd', dus schrijf je 'hond' met een d aan het einde.",
        "solutionSteps": [
          "Maak meervoud: hond → honden",
          "Je hoort de 'd'-klank",
          "Dus: hond (met d)"
        ]
      }
    },
    {
      "id": "SPR-WEET-D-T-007",
      "familyId": "SPR-WEET-D-T",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_eind",
      "questionType": "fill_in",
      "question": "Vul de juiste letter in: vel_. Typ het hele woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["veld"],
        "caseSensitive": false,
        "placeholder": "vel..."
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Meervoud-truc",
            "content": "Maak het woord meervoud: veld → velden. Je hoort de 'd', dus schrijf je 'veld' met een d.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "d_t_eind_fill_d2",
      "variantIndex": 7,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Meervoud-truc: veld → velden. Je hoort de 'd', dus schrijf je 'veld' met een d.",
        "solutionSteps": [
          "Maak meervoud: veld → velden",
          "Je hoort de 'd'-klank",
          "Dus: veld (met d)"
        ]
      }
    },
    {
      "id": "SPR-WEET-D-T-008",
      "familyId": "SPR-WEET-D-T",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_d_t_eind",
      "questionType": "fill_in",
      "question": "Vul de juiste letter in: kan_. Typ het hele woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["kant"],
        "caseSensitive": false,
        "placeholder": "kan..."
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Meervoud-truc",
            "content": "Maak het woord meervoud: kant → kanten. Je hoort de 't', dus schrijf je 'kant' met een t.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "d_t_eind_fill_t",
      "variantIndex": 8,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Meervoud-truc: kant → kanten. Je hoort de 't', dus schrijf je 'kant' met een t aan het einde.",
        "solutionSteps": [
          "Maak meervoud: kant → kanten",
          "Je hoort de 't'-klank",
          "Dus: kant (met t)"
        ]
      }
    }
  ]
}
